module.exports = __webpack_public_path__ + "img/Unidad9-2.edc0813c.png";